/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { NgModule } from '@angular/core';
import { IntlModule } from '@progress/kendo-angular-intl';
import { CustomAuthorizationService } from './core/auth/custom-authorization.service';

// Load all required data for the nl locale
import '@progress/kendo-angular-intl/locales/nl-BE/all';
import '@progress/kendo-angular-intl/locales/nl/all';
import '@progress/kendo-angular-intl/locales/ro/all';
import '@progress/kendo-angular-intl/locales/en-GB/all';
import '@progress/kendo-angular-intl/locales/de/all';

import { config } from './app.config';
import { KeepAliveService } from './core/auth/keep-alive.service';

let newProviders: any[] = [CustomAuthorizationService, KeepAliveService];
newProviders = newProviders.concat(config.providers);

config.imports.push(IntlModule);
config.providers = newProviders;

@NgModule(config)
export class AppModule { }



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/app.module.ts